<template>
  <div class="patients">
    <div class="w3-light-blue w3-padding">
      <h1>Select Patient</h1>
      <h2 class="w3-large">number of patients is: {{patientCount}}</h2>
      <div class="w3-margin-bottom">
        <button
          class="w3-button w3-red w3-margin-right"
          v-on:click="fetchPateientList()"
        >update patient list</button>
        <modal-container v-if="isPrivilegedUser" v-bind:labelText="'RegisterPatient'">
          <register-patient/>
        </modal-container>
      </div>
      <input
        type="text"
        class="w3-input w3-twothird"
        placeholder="patient name, surname, idnumber"
        v-on:keyup="searchTrigger"
        v-model="local_key"
        autofocus
      >
      <br>
      <br>
    </div>
    <patient-list class="w3-padding" v-on:patient-select="selectPatientHandler" v-bind:filteredList="filteredList"/>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import PatientList from "../components/PatientList.vue";
import ModalContainerVue from "../components/containers/ModalContainer.vue";
import RegisterPatientVue from "./RegisterPatient.vue";
import { setTimeout, clearTimeout } from 'timers';
export default {
  name: "patients",
  data: () => {
    return {
      local_key: "",
      filteredList: [],
      searchKeyUpTimeout: null
    };
  },
  components: {
    "patient-list": PatientList,
    "modal-container": ModalContainerVue,
    "register-patient": RegisterPatientVue
  },
  created() {
    this.local_key = this.$store.state.patientSearchKey;
    this.search();
  },
  computed: {
    ...mapGetters({patientCount:"patientCount", patientList:"getPatientList", isPrivilegedUser:"getIsprivilegedUser"}),
    // ...mapState(["patientList"]),
    patientSearchKey: {
      get: function() {
        // console.log(this.$store);
        return this.$store.state.patientSearchKey;
      },
      set: function(newVal) {
        this.$store.commit("UPDATE_PATIENT_SEARCH_KEY", newVal);
      }
    }
  },
  methods: {
    ...mapActions({fetchPateientList:"FETCH_PATIENT_LIST", removePatient:"REMOVE_PATIENT"}),
    searchTrigger(event){
      console.log("search pressed")
      clearTimeout(this.searchKeyUpTimeout)
      if(event.code === "Enter"){
        this.search();
      } else {
        this.searchKeyUpTimeout = setTimeout(()=>{
          console.log("searching triggered")
          this.search()
        }, 1000)
      }      
    },
    search() {
      // console.log("searching for: " + this.local_key);
      // console.log("patients count is: " + this.patientList.length)
      // console.log("patient is what?")
      // console.log( this.patientList[0]['name'] )
      var search_key = this.local_key.trim();
      this.patientSearchKey = search_key;
      var filteredList = [];
      var id_regex = /^[0-9]\d{10}$/;
      //id_regex.exec(search_key)
      //search only id numbers if only number is present
      if (id_regex.exec(search_key)) {
        console.log("searching with id");
        filteredList = this.searchID(this.patientList, search_key);
        console.log(filteredList);
      } else if (search_key != "") {
        console.log("searching with general match");
        filteredList = this.generalSearch(this.patientList, search_key);
      }

      this.filteredList = filteredList;
      window.scrollTo(0, 0);
    },
    searchID(patientList, key_id, limit = 99) {
      var filteredList = [];
      for (
        var i = 0, value = patientList[i];
        i < patientList.length;
        value = patientList[++i]
      ) {
        // console.log()
        if (value.id_number === key_id) {
          filteredList.push(patientList[i]);
        } else if (value.name && value['name'].includes(key_id)) {
          filteredList.push(patientList[i]);
        } else if (value.surname && value['surname'].includes(key_id)) {
          filteredList.push(patientList[i]);
        }
        if (filteredList.length > limit) {
          break;
        }
      }
      return filteredList;
    },
    generalSearch(patientList, search_key, limit = 99, precision = 100) {
      // console.log("patient_list: " + patientList);
      var filteredList = [];
      var key_tokens = search_key.split(" ").filter(token => {
        if (token == "ძე") {
          return false;
        } else if (token == "") {
          return false;
        }

        return true;
      });
      // console.log("tokens: " + key_tokens)
      // console.log(patientList)
      for (
        var i = 0, value = patientList[i];
        i < patientList.length;
        value = patientList[++i]
      ) {
        // console.log("searching in: ");
        // console.log("value");
        var match_level = 0;
        for (
          var j = 0, token = key_tokens[j];
          j < key_tokens.length;
          token = key_tokens[++j]
        ) {
          // console.log("name is " + value['name'])
          if (value.id_number === token) {
            match_level = key_tokens.length;
            break;
          } else if (value.id_number && value.id_number.includes(token)) {
            match_level++;
          } else if (value.name && value.name.includes(token)) {
            match_level++;
          } else if (value.surname && value.surname.includes(token)) {
            match_level++;
          }
        }
        // if match is adequate push to the list
        if (match_level >= key_tokens.length) {
          filteredList.push(patientList[i]);
        }
        if (filteredList.length > limit) {
          break;
        }
      }

      return filteredList;
    },
    selectPatientHandler(action, patient) {
      console.log("handling emited event: " + action + " on patient: ");
      console.log(patient)
      if (action === "select") {
        this.$router.push({ name: "patientPage", params: { patient_id: patient.patient_id } });
      } else if (action === "edit") {
        this.$router.push({ name: "editPatient", params: { patient_id: patient.patient_id } });
      } else if (action === "remove") {
        if (!confirm("Are you sure you want to delete patient: " + patient.name + " " + patient.surname)) return
        console.log("removing patient")
        console.log(patient)
        this.removePatient(patient)
          .then( result => {
            console.log("remove finished")
            if(result > 0){
              this.filteredList.splice( this.filteredList.findIndex( patientInList => patientInList.patient_id === patient.patient_id ) , 1 )
            }
          })
          .catch((error)=>console.log(error))
      }
    }
  }
};
</script>

<style scoped>
</style>
